// extracted by mini-css-extract-plugin
export var completionBody = "_l3-2";
export var completionCard = "_l3-0";
export var completionFooter = "_l3-3";
export var completionTitle = "_l3-1";